export const result = {
  status: 1,
  msg: '成功',
  data: [
    {
      ID: '2466',
      EventTypeEn: 'Boarded',
      ShipTypeEn: ' Offshore Tug ',
      AddressEn: ' Malacca Straits ',
      EventTime: '2024-03-26T00:00:00',
      DescribeEn:
        ' 26.03.2024: 0900 UTC: Posn: 01:24.35N – 103:13.98E, Malacca Straits. Four unauthorized persons in a fishing boat came alongside and boarded a drill ship towed by an offshore tug. The Master requested assistance from the IMB Piracy Reporting Centre who in turn contacted the MMEA resulting in a patrol boat being dispatched to the location. A search around the tow was carried out. No unauthorized persons were found. The vessel continued her journey. ',
      Area: '其它',
      Lat: 1.4058333333333333,
      Lng: 103.233,
      EventTypeCn: '登船',
      ShipTypeCn: ' Offshore Tug ',
      AddressCn: ' Malacca Straits ',
      DescribeCn:
        ' 26.03.2024: 0900 UTC: Posn: 01:24.35N – 103:13.98E, Malacca Straits. Four unauthorized persons in a fishing boat came alongside and boarded a drill ship towed by an offshore tug. The Master requested assistance from the IMB Piracy Reporting Centre who in turn contacted the MMEA resulting in a patrol boat being dispatched to the location. A search around the tow was carried out. No unauthorized persons were found. The vessel continued her journey. ',
      IsShow: 1,
      CreateTime: '2024-03-28T18:00:43',
      UpdateTime: '2024-03-28T18:00:43',
    },
    {
      ID: '2467',
      EventTypeEn: 'Boarded',
      ShipTypeEn: ' Bulk Carrier ',
      AddressEn: ' Chattogram Anchorage ',
      EventTime: '2024-03-29T00:00:00',
      DescribeEn:
        ' 27.03.2024: 2125 UTC: Posn: 21:48.7N – 091:47.9E, Chattogram Anchorage, Bangladesh. Eight robbers armed with knives boarded an anchored bulk carrier. Alarm raised, crew mustered, and a search was carried out. Seeing the crew alertness, the robbers escaped with stolen ship’s store. All crew members safe. ',
      Area: '孟加拉湾海盗区',
      Lat: 21.811666666666667,
      Lng: 91.798333333333332,
      EventTypeCn: '登船',
      ShipTypeCn: ' Bulk Carrier ',
      AddressCn: ' Chattogram Anchorage ',
      DescribeCn:
        ' 27.03.2024: 2125 UTC: Posn: 21:48.7N – 091:47.9E, Chattogram Anchorage, Bangladesh. Eight robbers armed with knives boarded an anchored bulk carrier. Alarm raised, crew mustered, and a search was carried out. Seeing the crew alertness, the robbers escaped with stolen ship’s store. All crew members safe. ',
      IsShow: 1,
      CreateTime: '2024-03-29T18:00:43',
      UpdateTime: '2024-03-29T18:00:43',
    },
    {
      ID: '2468',
      EventTypeEn: 'Attempted Attack',
      ShipTypeEn: ' General Cargo ',
      AddressEn: ' Chattogram Anchorage ',
      EventTime: '2024-03-30T00:00:00',
      DescribeEn:
        ' 29.03.2024: 1545 UTC: Posn: 22:14N – 091:42E, Chattogram Anchorage, Bangladesh Ship crew and security watchman onboard an anchored general cargo ship noticed three persons in a boat attempting to gain access to the vessel using a rope and hook. Alarm raised and crew mustered resulting in the persons aborting and moving away. ',
      Area: '孟加拉湾海盗区',
      Lat: 22.233333333333334,
      Lng: 91.7,
      EventTypeCn: '企图攻击',
      ShipTypeCn: ' General Cargo ',
      AddressCn: ' Chattogram Anchorage ',
      DescribeCn:
        ' 29.03.2024: 1545 UTC: Posn: 22:14N – 091:42E, Chattogram Anchorage, Bangladesh Ship crew and security watchman onboard an anchored general cargo ship noticed three persons in a boat attempting to gain access to the vessel using a rope and hook. Alarm raised and crew mustered resulting in the persons aborting and moving away. ',
      IsShow: 1,
      CreateTime: '2024-03-30T06:00:42',
      UpdateTime: '2024-03-30T06:00:42',
    },
    {
      ID: '2469',
      EventTypeEn: 'Boarded',
      ShipTypeEn: ' Bulk Carrier ',
      AddressEn: ' Kuala Tanjung Port ',
      EventTime: '2024-04-05T00:00:00',
      DescribeEn:
        " 03.04.2024: 1810 UTC: Posn: 03:22.3N – 099:28.2E, Kuala Tanjung Port, Indonesia Three robbers armed with knives boarded a berthed bulk carrier. They entered the engine room, took hostage the duty crew and tied his hands. The robbers released the duty crew before escaping with stolen ship's engine spare parts ",
      Area: '其它',
      Lat: 3.3675,
      Lng: 99.467222222222219,
      EventTypeCn: '登船',
      ShipTypeCn: ' Bulk Carrier ',
      AddressCn: ' Kuala Tanjung Port ',
      DescribeCn:
        " 03.04.2024: 1810 UTC: Posn: 03:22.3N – 099:28.2E, Kuala Tanjung Port, Indonesia Three robbers armed with knives boarded a berthed bulk carrier. They entered the engine room, took hostage the duty crew and tied his hands. The robbers released the duty crew before escaping with stolen ship's engine spare parts ",
      IsShow: 1,
      CreateTime: '2024-04-09T00:00:42',
      UpdateTime: '2024-04-09T00:00:42',
    },
    {
      ID: '2470',
      EventTypeEn: 'Boarded',
      ShipTypeEn: ' Product Tanker ',
      AddressEn: ' Balikpapan Anchorage ',
      EventTime: '2024-04-13T00:00:00',
      DescribeEn:
        ' 12.04.2024: 2125 UTC: Posn: 01:17.81S – 116:47.86E, Balikpapan Anchorage, Indonesia. An anchored product tanker was boarded by four perpetrators via the anchor chain. They broke into the forecastle store and escaped with ship’s stores and properties. Incident reported to Balikpapan port control. ',
      Area: '马六甲海峡海盗区',
      Lat: -1.2996666666666665,
      Lng: 116.79883333333333,
      EventTypeCn: '登船',
      ShipTypeCn: ' Product Tanker ',
      AddressCn: ' Balikpapan Anchorage ',
      DescribeCn:
        ' 12.04.2024: 2125 UTC: Posn: 01:17.81S – 116:47.86E, Balikpapan Anchorage, Indonesia. An anchored product tanker was boarded by four perpetrators via the anchor chain. They broke into the forecastle store and escaped with ship’s stores and properties. Incident reported to Balikpapan port control. ',
      IsShow: 1,
      CreateTime: '2024-04-19T00:00:44',
      UpdateTime: '2024-04-19T00:00:44',
    },
    {
      ID: '2471',
      EventTypeEn: 'Boarded',
      ShipTypeEn: ' Container ',
      AddressEn: ' Georgetown Port ',
      EventTime: '2024-04-13T00:00:00',
      DescribeEn:
        ' 12.04.2024: 2348 UTC: Posn: 06:48.6N - 058:10.1W, Georgetown Port, Guyana. A container vessel was boarded by three unauthorised persons armed with knives during berthing manoeuvres. Alarm raised and crew mustered resulting in the persons escaping. Incident reported to VTS. A patrol boat searched the seaside of the vessel while a security team performed a security search. ',
      Area: '其它',
      Lat: 6.8102222222222224,
      Lng: -58.167166666666667,
      EventTypeCn: '登船',
      ShipTypeCn: ' Container ',
      AddressCn: ' Georgetown Port ',
      DescribeCn:
        ' 12.04.2024: 2348 UTC: Posn: 06:48.6N - 058:10.1W, Georgetown Port, Guyana. A container vessel was boarded by three unauthorised persons armed with knives during berthing manoeuvres. Alarm raised and crew mustered resulting in the persons escaping. Incident reported to VTS. A patrol boat searched the seaside of the vessel while a security team performed a security search. ',
      IsShow: 1,
      CreateTime: '2024-04-19T00:00:44',
      UpdateTime: '2024-04-19T00:00:44',
    },
    {
      ID: '2472',
      EventTypeEn: 'Suspicious vessel',
      ShipTypeEn: ' Product Tanker ',
      AddressEn: ' Arabian Sea ',
      EventTime: '2024-04-20T00:00:00',
      DescribeEn:
        ' Suspicious Incident Report: This incident will not be added to the piracy incident figures. 20.04.2024: 0652 UTC: Posn: 12-45.31N 063-46.22E Arabian Sea. A tanker underway sighted a possible mother vessel with three small boats (blue and green coloured hull). One boat with four persons followed the tanker for at a speed of 14 knots for 30 mins. Weapons or ladders not sighted. ',
      Area: '索马里海盗区',
      Lat: 12.857166666666666,
      Lng: 63.73833333333333,
      EventTypeCn: '可疑船只',
      ShipTypeCn: ' Product Tanker ',
      AddressCn: ' Arabian Sea ',
      DescribeCn:
        ' Suspicious Incident Report: This incident will not be added to the piracy incident figures. 20.04.2024: 0652 UTC: Posn: 12-45.31N 063-46.22E Arabian Sea. A tanker underway sighted a possible mother vessel with three small boats (blue and green coloured hull). One boat with four persons followed the tanker for at a speed of 14 knots for 30 mins. Weapons or ladders not sighted. ',
      IsShow: 1,
      CreateTime: '2024-04-28T18:00:46',
      UpdateTime: '2024-04-28T18:00:46',
    },
    {
      ID: '2473',
      EventTypeEn: 'Boarded',
      ShipTypeEn: ' Bulk Carrier ',
      AddressEn: ' Singapore Straits ',
      EventTime: '2024-04-30T00:00:00',
      DescribeEn:
        ' 13.04.2024: 1847 UTC: Posn: 01:04.5N – 103:40.9E, Singapore Straits. Five robbers armed with pistols boarded a bulk carrier underway. They pointed pistols at the duty engineer, tied his hands and placed him face-down on the floor. General alarm raised, PA announcement made and crew mustered. VTIS informed. The robbers escaped with the stolen items. A search was made and ship’s engine spares were identified as stolen. ',
      Area: '其它',
      Lat: 1.075,
      Lng: 103.68166666666667,
      EventTypeCn: '登船',
      ShipTypeCn: ' Bulk Carrier ',
      AddressCn: ' Singapore Straits ',
      DescribeCn:
        ' 13.04.2024: 1847 UTC: Posn: 01:04.5N – 103:40.9E, Singapore Straits. Five robbers armed with pistols boarded a bulk carrier underway. They pointed pistols at the duty engineer, tied his hands and placed him face-down on the floor. General alarm raised, PA announcement made and crew mustered. VTIS informed. The robbers escaped with the stolen items. A search was made and ship’s engine spares were identified as stolen. ',
      IsShow: 1,
      CreateTime: '2024-05-02T00:00:47',
      UpdateTime: '2024-05-02T00:00:47',
    },
    {
      ID: '2474',
      EventTypeEn: 'Boarded',
      ShipTypeEn: ' Bulk Carrier ',
      AddressEn: ' Singapore Straits ',
      EventTime: '2024-05-06T00:00:00',
      DescribeEn:
        ' 05.03.2024: 1630 UTC: Posn: 01:06.68N – 103:44.95E, Singapore Straits. Three robbers armed with a rod boarded a bulk carrier underway. Duty crew noticed the robbers entering the engine room. Alarm raised and crew mustered. Seeing the crew alertness, the robbers escaped empty handed. ',
      Area: '其它',
      Lat: 1.1113333333333333,
      Lng: 103.74916666666667,
      EventTypeCn: '登船',
      ShipTypeCn: ' Bulk Carrier ',
      AddressCn: ' Singapore Straits ',
      DescribeCn:
        ' 05.03.2024: 1630 UTC: Posn: 01:06.68N – 103:44.95E, Singapore Straits. Three robbers armed with a rod boarded a bulk carrier underway. Duty crew noticed the robbers entering the engine room. Alarm raised and crew mustered. Seeing the crew alertness, the robbers escaped empty handed. ',
      IsShow: 1,
      CreateTime: '2024-05-07T18:00:46',
      UpdateTime: '2024-05-07T18:00:46',
    },
    {
      ID: '2475',
      EventTypeEn: 'Boarded',
      ShipTypeEn: ' Container ',
      AddressEn: ' Chattogram Anchorage ',
      EventTime: '2024-05-07T00:00:00',
      DescribeEn:
        ' 07.04.2024: 1958 UTC: Posn: 21:55.74N - 091:42.76E, Chattogram Anchorage, Bangladesh. Duty crew onboard an anchored container ship noticed two robbers near the forecastle store. Alarm raised, crew mustered and Coast Guard notified. Hearing the alarm the robbers escaped with ship stores. A Coast Guard boat responded and searched the sea area around the ship and later boarded the ship for investigations. ',
      Area: '孟加拉湾海盗区',
      Lat: 21.929,
      Lng: 91.712666666666664,
      EventTypeCn: '登船',
      ShipTypeCn: ' Container ',
      AddressCn: ' Chattogram Anchorage ',
      DescribeCn:
        ' 07.04.2024: 1958 UTC: Posn: 21:55.74N - 091:42.76E, Chattogram Anchorage, Bangladesh. Duty crew onboard an anchored container ship noticed two robbers near the forecastle store. Alarm raised, crew mustered and Coast Guard notified. Hearing the alarm the robbers escaped with ship stores. A Coast Guard boat responded and searched the sea area around the ship and later boarded the ship for investigations. ',
      IsShow: 1,
      CreateTime: '2024-05-07T18:00:46',
      UpdateTime: '2024-05-07T18:00:46',
    },
    {
      ID: '2476',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' Bulk Carrier ',
      AddressEn: ' Singapore Straits ',
      EventTime: '2024-05-08T00:00:00',
      DescribeEn:
        ' 29.03.2024: 1558 UTC: Posn: 01:03.43N – 103:39.22E, Singapore Straits. Three robbers armed with knives boarded a bulk carrier underway and entered the engine room. Alert duty crew noticed the robbers and raised the alarm, resulting in the robbers escaping empty-handed. All crew safe. ',
      Area: '其它',
      Lat: 1.0571666666666666,
      Lng: 103.65366666666667,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' Bulk Carrier ',
      AddressCn: ' Singapore Straits ',
      DescribeCn:
        ' 29.03.2024: 1558 UTC: Posn: 01:03.43N – 103:39.22E, Singapore Straits. Three robbers armed with knives boarded a bulk carrier underway and entered the engine room. Alert duty crew noticed the robbers and raised the alarm, resulting in the robbers escaping empty-handed. All crew safe. ',
      IsShow: 1,
      CreateTime: '2024-05-10T00:00:47',
      UpdateTime: '2024-05-10T00:00:47',
    },
    {
      ID: '2477',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' Container ',
      AddressEn: ' Manila Anchorage ',
      EventTime: '2024-05-10T00:00:00',
      DescribeEn:
        ' 09.05.2024: 1920 UTC: Posn: 14:35.59N – 120:50.75E, Manila Anchorage, Philippines. Duty crew onboard an anchored container ship noticed two unauthorised persons near the forecastle and immediately raised the alarm resulting in the persons escaping. Crew mustered and a search was carried out. Ship’s properties accounted as missing. Incident reported to VTMS Manila and the Philippines Coast Guard. ',
      Area: '其它',
      Lat: 14.598055555555556,
      Lng: 120.85361111111111,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' Container ',
      AddressCn: ' Manila Anchorage ',
      DescribeCn:
        ' 09.05.2024: 1920 UTC: Posn: 14:35.59N – 120:50.75E, Manila Anchorage, Philippines. Duty crew onboard an anchored container ship noticed two unauthorised persons near the forecastle and immediately raised the alarm resulting in the persons escaping. Crew mustered and a search was carried out. Ship’s properties accounted as missing. Incident reported to VTMS Manila and the Philippines Coast Guard. ',
      IsShow: 1,
      CreateTime: '2024-05-11T00:00:47',
      UpdateTime: '2024-05-11T00:00:47',
    },
    {
      ID: '2478',
      EventTypeEn: ' Fired Upon ',
      ShipTypeEn: ' Product Tanker ',
      AddressEn: ' Gulf of Aden ',
      EventTime: '2024-05-10T00:00:00',
      DescribeEn:
        ' 10.05.2024: 0457 UTC: Posn: 12:38.65N - 048:24.06E, Gulf of Aden. Around five to six pirates dressed in black clothes armed with AK-47 and RPG in a skiff approached a product tanker underway. Grapnel hook and ladder sighted. Master sounded ship’s horn and altered course. As the skiff continued to approach the armed guards showed their weapons. The pirates opened fire towards tanker and the armed team retaliated by firing four rounds causing a fire to break out on the boat. The tanker continued its voyage. ',
      Area: '索马里海盗区',
      Lat: 12.644166666666667,
      Lng: 48.401,
      EventTypeCn: ' Fired Upon ',
      ShipTypeCn: ' Product Tanker ',
      AddressCn: ' Gulf of Aden ',
      DescribeCn:
        ' 10.05.2024: 0457 UTC: Posn: 12:38.65N - 048:24.06E, Gulf of Aden. Around five to six pirates dressed in black clothes armed with AK-47 and RPG in a skiff approached a product tanker underway. Grapnel hook and ladder sighted. Master sounded ship’s horn and altered course. As the skiff continued to approach the armed guards showed their weapons. The pirates opened fire towards tanker and the armed team retaliated by firing four rounds causing a fire to break out on the boat. The tanker continued its voyage. ',
      IsShow: 1,
      CreateTime: '2024-05-14T00:00:48',
      UpdateTime: '2024-05-14T00:00:48',
    },
    {
      ID: '2479',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' Product Tanker ',
      AddressEn: ' Chattogram Anchorage ',
      EventTime: '2024-05-13T00:00:00',
      DescribeEn:
        ' 12.05.2024: 2145 UTC: Posn: 22:16.9N - 091:42.6E, Chattogram Anchorage, Bangladesh. Five robbers armed with long knives boarded an anchored tanker. Duty AB on rounds noticed some movements at the poop deck and raised the alarm. Crew mustered and a search was carried out. Two watchmen were found tied up. Paint store lock was broken and ship’s stores stolen. Incident reported to coast guard. ',
      Area: '孟加拉湾海盗区',
      Lat: 22.282222222222224,
      Lng: 91.71,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' Product Tanker ',
      AddressCn: ' Chattogram Anchorage ',
      DescribeCn:
        ' 12.05.2024: 2145 UTC: Posn: 22:16.9N - 091:42.6E, Chattogram Anchorage, Bangladesh. Five robbers armed with long knives boarded an anchored tanker. Duty AB on rounds noticed some movements at the poop deck and raised the alarm. Crew mustered and a search was carried out. Two watchmen were found tied up. Paint store lock was broken and ship’s stores stolen. Incident reported to coast guard. ',
      IsShow: 1,
      CreateTime: '2024-05-14T00:00:48',
      UpdateTime: '2024-05-14T00:00:48',
    },
    {
      ID: '2480',
      EventTypeEn: ' Hijacked ',
      ShipTypeEn: ' Dhow ',
      AddressEn: ' Around 60nm East of Raas Cabaad ',
      EventTime: '2024-05-15T00:00:00',
      DescribeEn:
        ' 13.05.2024: 1125 UTC: Posn: 06:21N - 050:06E, Around 60nm East of Raas Cabaad, Somalia. Around six to seven pirates in a skiff armed with AK-47 boarded and hijacked a fishing vessel underway. The pirates released the 21 crew and the fishing vessel after food and logistical supplies were stolen. An Indian Naval Warship boarded and escorted the vessel to a safe distance. ',
      Area: '索马里海盗区',
      Lat: 6.35,
      Lng: 50.1,
      EventTypeCn: ' Hijacked ',
      ShipTypeCn: ' Dhow ',
      AddressCn: ' Around 60nm East of Raas Cabaad ',
      DescribeCn:
        ' 13.05.2024: 1125 UTC: Posn: 06:21N - 050:06E, Around 60nm East of Raas Cabaad, Somalia. Around six to seven pirates in a skiff armed with AK-47 boarded and hijacked a fishing vessel underway. The pirates released the 21 crew and the fishing vessel after food and logistical supplies were stolen. An Indian Naval Warship boarded and escorted the vessel to a safe distance. ',
      IsShow: 1,
      CreateTime: '2024-05-16T06:00:45',
      UpdateTime: '2024-05-16T06:00:45',
    },
    {
      ID: '2481',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' Product Tanker ',
      AddressEn: ' Around 363nm SSW of Nova Sintra ',
      EventTime: '2024-05-18T00:00:00',
      DescribeEn:
        ' 17.05.2024: 0410 UTC: Posn: 09:11.2N – 027:03.9W, Around 363nm SSW of Nova Sintra, Cabo Verde. Ten pirates armed with AK-47 boarded a product tanker underway and took control of the bridge. All crew muster on the bridge where the pirates tied up their hands and legs. The pirates ordered the 2/E and 4/E to stop engines and drift with the intention of stealing the cargo and bunkers. While waiting for the off take vessel the pirates stole crew and ship properties. They then moved all the crew into the steering gear room and informed the crew that there were explosive devices fixed on all doors and the crew could only exit after two hours. Once the crew emerged from the steering gear room no pirates or explosives found. The pirates had damaged communication, internet, navigation equipment and the air control pipes for the main engine and cylinder oil flow valves before escaping. The crew managed to sail the vessel to the next port. No cargo or bunkers stolen. ',
      Area: '其它',
      Lat: 9.1866666666666674,
      Lng: -27.065,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' Product Tanker ',
      AddressCn: ' Around 363nm SSW of Nova Sintra ',
      DescribeCn:
        ' 17.05.2024: 0410 UTC: Posn: 09:11.2N – 027:03.9W, Around 363nm SSW of Nova Sintra, Cabo Verde. Ten pirates armed with AK-47 boarded a product tanker underway and took control of the bridge. All crew muster on the bridge where the pirates tied up their hands and legs. The pirates ordered the 2/E and 4/E to stop engines and drift with the intention of stealing the cargo and bunkers. While waiting for the off take vessel the pirates stole crew and ship properties. They then moved all the crew into the steering gear room and informed the crew that there were explosive devices fixed on all doors and the crew could only exit after two hours. Once the crew emerged from the steering gear room no pirates or explosives found. The pirates had damaged communication, internet, navigation equipment and the air control pipes for the main engine and cylinder oil flow valves before escaping. The crew managed to sail the vessel to the next port. No cargo or bunkers stolen. ',
      IsShow: 1,
      CreateTime: '2024-05-18T18:00:44',
      UpdateTime: '2024-05-18T18:00:44',
    },
    {
      ID: '2483',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' General Cargo ',
      AddressEn: ' Dumai Anchorage ',
      EventTime: '2024-05-20T00:00:00',
      DescribeEn:
        ' 14.05.2024: 2117 UTC: Posn: 01:42.4N – 101:28.3E, Dumai Anchorage, Indonesia. Duty crew onboard an anchored general cargo ship noticed three unauthorised persons attempting to enter the engine room. Alarm raised and PA announcement made resulting in the persons escaping empty handed. ',
      Area: '其它',
      Lat: 1.7066666666666666,
      Lng: 101.47166666666666,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' General Cargo ',
      AddressCn: ' Dumai Anchorage ',
      DescribeCn:
        ' 14.05.2024: 2117 UTC: Posn: 01:42.4N – 101:28.3E, Dumai Anchorage, Indonesia. Duty crew onboard an anchored general cargo ship noticed three unauthorised persons attempting to enter the engine room. Alarm raised and PA announcement made resulting in the persons escaping empty handed. ',
      IsShow: 1,
      CreateTime: '2024-05-21T18:00:46',
      UpdateTime: '2024-05-21T18:00:46',
    },
    {
      ID: '2484',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' Container ',
      AddressEn: ' Conakry Port ',
      EventTime: '2024-05-21T00:00:00',
      DescribeEn:
        ' 14.05.2024: 0500 UTC: Posn: 09:30.57N – 013:43.40W, Conakry Port, Guinea. Unnoticed robbers boarded a berthed container ship, stole rescue boat outboard engine and escaped. The theft was noticed after the vessel sailed. ',
      Area: '其它',
      Lat: 9.5095,
      Lng: -13.723333333333333,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' Container ',
      AddressCn: ' Conakry Port ',
      DescribeCn:
        ' 14.05.2024: 0500 UTC: Posn: 09:30.57N – 013:43.40W, Conakry Port, Guinea. Unnoticed robbers boarded a berthed container ship, stole rescue boat outboard engine and escaped. The theft was noticed after the vessel sailed. ',
      IsShow: 1,
      CreateTime: '2024-05-23T00:00:47',
      UpdateTime: '2024-05-23T00:00:47',
    },
    {
      ID: '2485',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' Bulk Carrier ',
      AddressEn: ' Singapore Straits ',
      EventTime: '2024-05-21T00:00:00',
      DescribeEn:
        " 20.05.2024: 2040 UTC: Posn: 01:04.3N – 103:35.7E, Singapore Straits. Five robbers armed with knives boarded an underway bulk carrier. They entered the engine room, took hostage the duty crew and tied his hands. The robbers released the duty crew before escaping with stolen ship's engine spare parts. ",
      Area: '其它',
      Lat: 1.0675,
      Lng: 103.58527777777778,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' Bulk Carrier ',
      AddressCn: ' Singapore Straits ',
      DescribeCn:
        " 20.05.2024: 2040 UTC: Posn: 01:04.3N – 103:35.7E, Singapore Straits. Five robbers armed with knives boarded an underway bulk carrier. They entered the engine room, took hostage the duty crew and tied his hands. The robbers released the duty crew before escaping with stolen ship's engine spare parts. ",
      IsShow: 1,
      CreateTime: '2024-05-28T00:00:48',
      UpdateTime: '2024-05-28T00:00:48',
    },
    {
      ID: '2486',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' General Cargo ',
      AddressEn: ' Around 400nm SE of Mogadishu ',
      EventTime: '2024-05-24T00:00:00',
      DescribeEn:
        ' 23.05.2024: 1045 UTC: Posn: 01:16S – 051:07E, Around 400nm SE of Mogadishu. Somalia. Armed pirates in two small crafts boarded a general cargo ship underway. The crew took shelter in the citadel. EUNAVFOR informed by the CSO. A warship proceeds to the location to assist, and a helicopter arrived at the scene. The pirates escaped. Crew and the ship were secured. All crew are safe. ',
      Area: '索马里海盗区',
      Lat: -1.2666666666666666,
      Lng: 51.116666666666667,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' General Cargo ',
      AddressCn: ' Around 400nm SE of Mogadishu ',
      DescribeCn:
        ' 23.05.2024: 1045 UTC: Posn: 01:16S – 051:07E, Around 400nm SE of Mogadishu. Somalia. Armed pirates in two small crafts boarded a general cargo ship underway. The crew took shelter in the citadel. EUNAVFOR informed by the CSO. A warship proceeds to the location to assist, and a helicopter arrived at the scene. The pirates escaped. Crew and the ship were secured. All crew are safe. ',
      IsShow: 1,
      CreateTime: '2024-05-28T00:00:48',
      UpdateTime: '2024-05-28T00:00:48',
    },
    {
      ID: '2487',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' Bulk Carrier ',
      AddressEn: ' Dumai Anchorage ',
      EventTime: '2024-05-26T00:00:00',
      DescribeEn:
        ' 24.05.2024: 1910 UTC: Posn: 01:42N – 101:29E, Dumai Anchorage, Indonesia. Around 3-4 robbers armed with knives and iron bars boarded an anchored bulk carrier. They stole ship’s engine spares and escaped. The theft was noticed on the CCTV. Incident reported to Dumai VTS by VHF. ',
      Area: '其它',
      Lat: 1.7,
      Lng: 101.48333333333333,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' Bulk Carrier ',
      AddressCn: ' Dumai Anchorage ',
      DescribeCn:
        ' 24.05.2024: 1910 UTC: Posn: 01:42N – 101:29E, Dumai Anchorage, Indonesia. Around 3-4 robbers armed with knives and iron bars boarded an anchored bulk carrier. They stole ship’s engine spares and escaped. The theft was noticed on the CCTV. Incident reported to Dumai VTS by VHF. ',
      IsShow: 1,
      CreateTime: '2024-05-28T00:00:48',
      UpdateTime: '2024-05-28T00:00:48',
    },
    {
      ID: '2488',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' General Cargo ',
      AddressEn: ' Dumai Anchorage ',
      EventTime: '2024-05-27T00:00:00',
      DescribeEn:
        ' 28.02.2024: 1816 UTC: Posn: 01:46N – 101:22E, Dumai Anchorage, Indonesia. Duty crew onboard an anchored general cargo ship noticed four unauthorised persons and raised the alarm. Seeing the crew alertness, the persons escaped without stealing anything. Coast Guard boarded the ship for inspection. ',
      Area: '其它',
      Lat: 1.7666666666666666,
      Lng: 101.36666666666666,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' General Cargo ',
      AddressCn: ' Dumai Anchorage ',
      DescribeCn:
        ' 28.02.2024: 1816 UTC: Posn: 01:46N – 101:22E, Dumai Anchorage, Indonesia. Duty crew onboard an anchored general cargo ship noticed four unauthorised persons and raised the alarm. Seeing the crew alertness, the persons escaped without stealing anything. Coast Guard boarded the ship for inspection. ',
      IsShow: 1,
      CreateTime: '2024-05-28T00:00:48',
      UpdateTime: '2024-05-28T00:00:48',
    },
    {
      ID: '2489',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' General Cargo ',
      AddressEn: ' Vung Tau Anchorage ',
      EventTime: '2024-05-29T00:00:00',
      DescribeEn:
        ' 29.05.2024: 1220 UTC: Posn: 10:12N – 107:03E, Vung Tau Anchorage, Vietnam. An unauthorised person boarded an anchored general cargo ship. Alert Duty Crew noticed the individual, shouted at him and raised the alarm resulting in the person escaping empty-handed in a wooden boat along with two accomplices. ',
      Area: '马六甲海峡海盗区',
      Lat: 10.2,
      Lng: 107.05,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' General Cargo ',
      AddressCn: ' Vung Tau Anchorage ',
      DescribeCn:
        ' 29.05.2024: 1220 UTC: Posn: 10:12N – 107:03E, Vung Tau Anchorage, Vietnam. An unauthorised person boarded an anchored general cargo ship. Alert Duty Crew noticed the individual, shouted at him and raised the alarm resulting in the person escaping empty-handed in a wooden boat along with two accomplices. ',
      IsShow: 1,
      CreateTime: '2024-06-01T18:00:47',
      UpdateTime: '2024-06-01T18:00:47',
    },
    {
      ID: '2490',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' General Cargo ',
      AddressEn: ' Around 28nm SW of Malabo Island, Equatorial Guinea ',
      EventTime: '2024-06-03T00:00:00',
      DescribeEn:
        ' 29.05.2024: 2110 UTC: Posn: 03:12N - 007:58E, Around 28nm SW of Malabo Island, Equatorial Guinea. About nine pirates boarded a ship underway. They escaped with stolen GMDSS equipment, ship provisions, crew personal effects and kidnapped the Master and Chief Engineer. Remaining crew sailed the vessel to a safe port. ',
      Area: '西非海盗区',
      Lat: 3.2,
      Lng: 7.9666666666666668,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' General Cargo ',
      AddressCn: ' Around 28nm SW of Malabo Island, Equatorial Guinea ',
      DescribeCn:
        ' 29.05.2024: 2110 UTC: Posn: 03:12N - 007:58E, Around 28nm SW of Malabo Island, Equatorial Guinea. About nine pirates boarded a ship underway. They escaped with stolen GMDSS equipment, ship provisions, crew personal effects and kidnapped the Master and Chief Engineer. Remaining crew sailed the vessel to a safe port. ',
      IsShow: 1,
      CreateTime: '2024-06-05T00:00:49',
      UpdateTime: '2024-06-05T00:00:49',
    },
    {
      ID: '2491',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' Bulk Carrier ',
      AddressEn: ' Singapore Straits ',
      EventTime: '2024-06-11T00:00:00',
      DescribeEn:
        ' 10.06.2024: 2035 UTC: Posn: 01:08.3N – 103:28.9E, Singapore Straits. Four robbers armed with knives boarded a bulk carrier underway and entered the engine room. Duty engineer noticed the robbers and informed the OOW. Alarm raised and PA announcement made, resulting in the robbers escaping. A search was made, and ship’s engine spares were identified as stolen. ',
      Area: '其它',
      Lat: 1.1341666666666668,
      Lng: 103.46916666666667,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' Bulk Carrier ',
      AddressCn: ' Singapore Straits ',
      DescribeCn:
        ' 10.06.2024: 2035 UTC: Posn: 01:08.3N – 103:28.9E, Singapore Straits. Four robbers armed with knives boarded a bulk carrier underway and entered the engine room. Duty engineer noticed the robbers and informed the OOW. Alarm raised and PA announcement made, resulting in the robbers escaping. A search was made, and ship’s engine spares were identified as stolen. ',
      IsShow: 1,
      CreateTime: '2024-06-12T18:00:47',
      UpdateTime: '2024-06-12T18:00:47',
    },
    {
      ID: '2492',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' Bulk Carrier ',
      AddressEn: ' Singapore Straits ',
      EventTime: '2024-06-12T00:00:00',
      DescribeEn:
        ' 10.06.2024: 2030 UTC: Posn: 01:03.4N - 103:37.5E, Singapore Straits. Six robbers armed with knives, boarded a bulk carrier underway. C/E informed the OOW that two crews were found tied up in the E/rm workshop. Alarm raised and PA announcement made. A search was carried out and one crew who was also tied up by the robbers found on the upper deck. Ship’s engine spare parts and crew personal belongings reported as stolen. Incident reported to Singapore Authorities after anchoring. ',
      Area: '其它',
      Lat: 1.0511111111111111,
      Lng: 103.61805555555556,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' Bulk Carrier ',
      AddressCn: ' Singapore Straits ',
      DescribeCn:
        ' 10.06.2024: 2030 UTC: Posn: 01:03.4N - 103:37.5E, Singapore Straits. Six robbers armed with knives, boarded a bulk carrier underway. C/E informed the OOW that two crews were found tied up in the E/rm workshop. Alarm raised and PA announcement made. A search was carried out and one crew who was also tied up by the robbers found on the upper deck. Ship’s engine spare parts and crew personal belongings reported as stolen. Incident reported to Singapore Authorities after anchoring. ',
      IsShow: 1,
      CreateTime: '2024-06-13T00:00:49',
      UpdateTime: '2024-06-13T00:00:49',
    },
    {
      ID: '2493',
      EventTypeEn: ' Boarded ',
      ShipTypeEn: ' Bulk Carrier ',
      AddressEn: ' Singapore Straits ',
      EventTime: '2024-06-14T00:00:00',
      DescribeEn:
        ' 27.05.2024: 1845 UTC: Posn: 01:09.40N - 103:27.55E, Singapore Straits. Four unauthorised persons boarded an anchored bulk carrier, stole ship’s engine spares and escaped. The theft was noticed on the CCTV after the vessel sailed. Incident reported to Singapore Authorities. ',
      Area: '其它',
      Lat: 1.1566666666666667,
      Lng: 103.45916666666666,
      EventTypeCn: ' Boarded ',
      ShipTypeCn: ' Bulk Carrier ',
      AddressCn: ' Singapore Straits ',
      DescribeCn:
        ' 27.05.2024: 1845 UTC: Posn: 01:09.40N - 103:27.55E, Singapore Straits. Four unauthorised persons boarded an anchored bulk carrier, stole ship’s engine spares and escaped. The theft was noticed on the CCTV after the vessel sailed. Incident reported to Singapore Authorities. ',
      IsShow: 1,
      CreateTime: '2024-06-18T18:00:47',
      UpdateTime: '2024-06-18T18:00:47',
    },
    {
      ID: '2494',
      EventTypeEn: ' Attempted ',
      ShipTypeEn: ' Chemical Tanker ',
      AddressEn: ' Singapore Straits ',
      EventTime: '2024-06-18T00:00:00',
      DescribeEn:
        ' 15.06.2024: 1212 UTC: Posn: 01:14.5N – 104:03.5E, Singapore Straits. A chemical tanker underway sighted a dimly lit boat near the port bow and altered course. At a distance of 1.5nm, the boat suddenly started flashing lights, increased speed towards the tanker and made an approach in an attempt to come alongside. The tanker took evasive manoeuvres and notified VTIS. A patrol boat arrived to assist the tanker. Seeing the patrol boat, the boat aborted and moved away. ',
      Area: '其它',
      Lat: 1.2416666666666667,
      Lng: 104.05833333333334,
      EventTypeCn: ' Attempted ',
      ShipTypeCn: ' Chemical Tanker ',
      AddressCn: ' Singapore Straits ',
      DescribeCn:
        ' 15.06.2024: 1212 UTC: Posn: 01:14.5N – 104:03.5E, Singapore Straits. A chemical tanker underway sighted a dimly lit boat near the port bow and altered course. At a distance of 1.5nm, the boat suddenly started flashing lights, increased speed towards the tanker and made an approach in an attempt to come alongside. The tanker took evasive manoeuvres and notified VTIS. A patrol boat arrived to assist the tanker. Seeing the patrol boat, the boat aborted and moved away. ',
      IsShow: 1,
      CreateTime: '2024-06-19T18:00:45',
      UpdateTime: '2024-06-19T18:00:45',
    },
  ],
  area: [
    { num: 2, area: '马六甲海峡海盗区' },
    { num: 4, area: '孟加拉湾海盗区' },
    { num: 4, area: '索马里海盗区' },
    { num: 1, area: '西非海盗区' },
    { num: 17, area: '其它' },
  ],
}
